import { DeleteOutlined } from "@ant-design/icons";

import { RVConfirmationTriggerModalButton } from "@regal-voice/ui";

export function DeleteButton({
    disabled,
    removePending,
    handleRemove,
}: {
    disabled: boolean;
    removePending: boolean;
    handleRemove: () => Promise<void>;
}): JSX.Element {
    return (
        <RVConfirmationTriggerModalButton
            disabled={disabled}
            loading={removePending}
            handleMethod={handleRemove}
            danger={true}
            buttonText="Delete"
            title="Delete Journey?"
            content={
                <>
                    <span>
                        Deleting this journey will cause in-progress contacts to exit the journey and remove the journey
                        from your account.
                    </span>
                </>
            }
            confirmText="Yes, Delete Journey"
            okLoading="Deleting Journey"
            icon={<DeleteOutlined />}
        />
    );
}
